(function($) {
  'use strict';

  const carousel = {
    dom: function() {
      this.$carousel = $('.carousel');
      this.$items = $('[data-carousel]');
    },

    carousel: function() {
      this.$items.each(function(index, element) {
        const splide = new Splide(element, {
          type: 'slide',
          // type: 'loop',
          arrows: true,
          arrowPath: 'm22.88,5.08c.87-.87,2.27-.87,3.14,0l13.36,13.36s.13.13.18.2c0,0,.02.02.04.04.04.04.07.11.11.16,0,.02.02.04.04.09l.07.13s.04.07.04.11.04.09.04.13c0,.02,0,.07.02.11,0,.04.02.09.04.16v.11c0,.11.02.22.02.33v-.2.6s0,.09-.04.16c0,.04,0,.07-.02.11,0,.04-.02.09-.04.13,0,.04-.02.09-.04.11,0,.04-.04.09-.07.13,0,.02-.02.04-.04.09-.04.07-.07.11-.11.16-.07.09-.13.18-.22.24l.18-.2h0l-.16.18-13.36,13.36c-.87.87-2.27.87-3.14,0-.87-.87-.87-2.27,0-3.14l9.55-9.55H2.2c-1.14,0-2.09-.87-2.2-1.96v-.27c0-1.22.98-2.23,2.2-2.23h30.25l-9.57-9.5c-.8-.8-.87-2.07-.18-2.94l.18-.2v-.02Z',
          pagination: false,
          // focus     : 'center',
          // padding: 'var(--padding)',
          padding: '5px',
          autoWidth: true,
          perMove: 1,
          breakpoints: {
            825: {
              arrows: false,
            },
          }
        });
        splide.mount();
      });
    },

    gsap: function() {
      const _ = this;

      _.$carousel.each(function() {
        const $this = $(this);
        const $container = $this.find('.carousel__container');
        gsap.fromTo($container, {
          y: '20%',
          x: '0%',
          opacity: 0
        }, {
          scrollTrigger: {
            trigger: $this,
            start: 'top bottom',
            end: 'top 75%',
            toggleActions: 'restart none reverse reset',
            scrub: true
          },
          y: 0,
          x: 0,
          opacity: 1
        });
      });
    },

    ready: function() {
      this.dom();
      this.carousel();
      this.gsap();
    }
  };

  $(function() { carousel.ready(); });

})(jQuery);
